import $ from 'jquery';
import _ from 'lodash';
import {SisName} from 'util/SisName'
import {EntryDescStateType} from 'module/edesc/reducer/EntryDescReducer'
import {Booking, EntryDesc, Persurl, PlanEvent} from 'generated/JavaTOmodifications'
import {ColorPairTO, CustomFieldTO} from 'generated/JavaTO'
import {EventDialogModel} from 'module/EventDialog/type/EventDialogType'
import {getDeviceForApp} from 'util/AppName'
import {TerminalModel} from 'appmodule/term/type/terminalType'
import {CSSProperties} from 'react'

/**
 * @typedef CFInputType CFInputType
 * @readonly
 * @enum {number}
 */
export enum CFInputType {
	DropDownNumberPad = 0,
	Autocomplete = 1,
	AutocompleteValueLabel = 2,
	AutocompleteValueList = 3,
	DqButtons = 4,
	DqConvert = 5,
	DqLabel = 6,
}

/**
 * defines the color of the booking (in list means uses normal colors, not in list uses terminal colors)
 * @type {string[]} case sensitive
 */
let APP_DEVICES: string[] // server property / default value
export const fetchAppDeviceStrings = () => {
	return $.ajax({url: "../json/property/devices"}).done(function (response) {
		APP_DEVICES = response
		Object.freeze(APP_DEVICES)
	})
}

export const isAppDevice = (dev?: string) => {
	return _.includes(APP_DEVICES, dev);
}

export const isTerminalDevice = (dev?: string) => {
	return !isAppDevice(dev);
}

export const getEntryDescColorObj = (entryDesc: EntryDesc | undefined, dev: string = getDeviceForApp()) => {
	if (!entryDesc) return {} as ColorPairTO
	return isTerminalDevice(dev) ? entryDesc.terminalColor : entryDesc.typeColor;
}

export function getEntryDescStyleObj(entryDesc: EntryDesc, dev?: string): CSSProperties {
	const o = getEntryDescColorObj(entryDesc, dev)
	return {color: o.textColor, background: o.bgColor}
}

export const hasCFInputFeature = (cfDef: CustomFieldTO, cfInputType: CFInputType) => {
	if (!cfDef) return false;
	const inp = (cfDef.input || '') + '';
	//app
	if (inp[0] !== '1') return false;
	switch (cfInputType) {
		case CFInputType.DropDownNumberPad:
			if (+inp[1] > 0) return true;
			break;
		case CFInputType.Autocomplete:
			if (+inp[2] > 0 && +inp[2] < 5) return true;
			break;
		case CFInputType.AutocompleteValueLabel:
			if (inp[2] === '1' || inp[2] === '2') return true;
			break;
		case CFInputType.AutocompleteValueList:
			if (inp[2] === '1' || inp[2] === '3') return true;
			break;
		case CFInputType.DqButtons:
			if (inp[2] === 'B') return true;
			break;
		case CFInputType.DqConvert:
			if (inp[2] === 'X') return true;
			break;
		case CFInputType.DqLabel: //todo
			if (inp[2] === 'L') return true;
			break;
	}
	return false;
};

//redux util
type EntryDescById = EntryDescStateType['EntryDesc']['byId']

export function findEntryDescForModel<T extends EventDialogModel | TerminalModel>(entryDescById: EntryDescById, attr: any) {
	if (!attr || _.isEmpty(entryDescById)) return undefined;
	let {bookingType, hourCategory} = attr;
	bookingType = _.trim(bookingType) || ' ';
	hourCategory = _.trim(hourCategory) || ' ';
	return _.find(entryDescById, {bookingType, hourCategory});
}

export function setEntryDesc(entryDesc: EntryDesc | null | undefined, attr: object | null | undefined) {
	if (!attr) return attr
	if (entryDesc) {
		const {sisName, id: _edId, hourCategory, bookingType} = entryDesc
		if (sisName === SisName.Booking) {
			return {...attr, sisName, _edId, hourCategory, bookingType} as Booking
		} else {
			return {...attr, sisName, _edId, hourCategory} as Persurl
		}
	}
	const {sisName, hourCategory, bookingType, _edId, ...ret} = attr as any
	return ret // unset
}

export function transformBSToEntryDescId<T extends Booking | Persurl | PlanEvent | null | undefined>(entryDescById: EntryDescById, attr: T): T {
	if (!attr) return attr
	const sisName = attr.sisName
	if (sisName !== SisName.Booking && sisName !== SisName.Persurl && sisName !== SisName.PlanEvent) return attr as unknown as T // don't do anything with everything else
	// @ts-ignore because Persurl has no bookingType
	const {bookingType, hourCategory} = attr
	const ed = findEntryDescForModel(entryDescById, {bookingType, hourCategory})
	return setEntryDesc(ed, {...attr}) as T
}